module.exports = __webpack_public_path__ + "static/media/secondarylogo.10a08351.svg";